import { render } from "./Tuklab.vue?vue&type=template&id=475354c8&scoped=true"
import script from "./Tuklab.vue?vue&type=script&lang=js"
export * from "./Tuklab.vue?vue&type=script&lang=js"

import "./Tuklab.vue?vue&type=style&index=0&id=475354c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475354c8"]])

export default __exports__